import styled from 'styled-components';

const shouldForwardProp = prop => !['isOpen'].includes(prop);

export const DependentsStyled = styled.div.withConfig({ shouldForwardProp })`
  display: flex;
  flex-direction: column;
  gap: 20px;

  .dependentsInfoCard {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 16px;
    width: 100%;
  }
  .dependentsInfoCardItem {
    padding: 16px;
    background: var(--GrayScale-100);
    display: flex;
    flex-direction: column;
    gap: 16px;
    border-radius: 16px;
    width: 100%;
  }

  .dependentsInfoCardItemLine {
    width: 100%;
    height: 1px;
    border-top: 1px dashed var(--GrayScale-600);
  }

  .dependentsInfoCardItemTop {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
  }

  .dependentsInfoCardItemBottom {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
`;
